import React from "react";
import { Link } from 'react-router-dom';

var d = new Date();
var currYear = d.getFullYear();
const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h6 className="link-p"><Link to="/privacy-policy">Privacy Policy</Link></h6>
            <p className="adrs-hd">Disclaimer- This is an independent Service centre. We are the Largest &amp; Fastest Growing Service Provider &amp; We undertake job work of Service, AMC, Repair &amp; Maintenance of RO Service &amp; repair, we are totally responsible for these and no relation to any company in any regards.</p>
            <br />

              <p>Business Relationship, Company Name- SAFE WATER TECHNOLOGIES, Company Address: East Delhi, Delhi <br />	© {currYear} Safe Water Technologies. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
